module.exports = __webpack_public_path__ + "img/2.01449190.jpg";